<template>
  <div class="fill-height">
    <v-layout row wrap>
      <v-flex>
        <section>
          <v-img
            width="100%"
            height="100vh"
            alt="kominfoklaten"
            class="px-8"
            gradient="to top right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)"
            :src="require('@/assets/background/bg_2.jpg')">
            <v-row 
              align="center" 
              justify="center"
              style="height: 100vh;">
              <v-col 
                cols="12"
                md="3">
                <v-card
                  flat
                  color="transparent">
                  <div>
                    <v-card
                      flat
                      color="#ffffffcf"
                      class="border-radius">
                      <v-card-text
                        class="pa-8">
                        <div
                          class="text-center mb-6">
                          <div
                            class="title font-weight-bold black--text mb-2">
                            Masuk Admin
                          </div>
                        </div>

                        <ValidationObserver 
                          ref="observer">
                          <v-form class="text-left mb-6">
                            <ValidationProvider 
                              name="username" 
                              rules="required" 
                              v-slot="{ errors }">
                              <v-text-field
                                v-on:keyup.enter="recaptcha()"
                                class="no_box"
                                solo
                                :color="set_color"
                                placeholder="Username"
                                prepend-inner-icon="mdi-account-outline"

                                vv-uppercase

                                v-model="form.username"
                                :error-messages="errors"
                                required>
                              </v-text-field>
                            </ValidationProvider>

                            <ValidationProvider 
                              name="password" 
                              rules="required|min:5|max:20" 
                              v-slot="{ errors }">
                              <v-text-field
                                v-on:keyup.enter="save()"
                                class="no_box"
                                solo
                                :color="set_color"
                                placeholder="Password"
                                :type="show ? 'text' : 'password'"
                                prepend-inner-icon="mdi-lock-outline"
                                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="show = !show"
                                :counter="50"

                                vv-uppercase
                                
                                v-model="form.password"
                                :error-messages="errors"
                                required>
                              </v-text-field>
                            </ValidationProvider>
                          </v-form>
                        </ValidationObserver> 

                        <div 
                          class="text-center mb-6">
                          <div v-if="message.error.length > 0"
                            class="text-center my-4">
                            <div
                              class="error--text d-flex align-start font-weight-medium">
                              <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                              
                              <span
                                class="ml-1">
                                {{ message.error }}
                              </span>
                            </div>
                          </div>

                          <v-btn
                            v-on:keyup.enter="save"
                            :disabled="process.form"
                            :loading="process.form"
                            @click="recaptcha()"
                            block
                            x-large
                            width="170"
                            elevation="0"
                            class="title font-weight-bold white--text text-capitalize"
                            style="border-radius: 10px; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                            Masuk 
                          </v-btn>
                        </div>

                        <!-- <div
                          class="body-2 text-center black--text">
                          Lupa password ?
                        </div> -->
                      </v-card-text>
                    </v-card>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-img>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        show: false,
        form: {
          username: '',
          password: '',
          device: 'web'
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      }
    },
    mounted () {
      this.fetch()

      let counter = {
        total_company_quota: 0,
        total_company_quota_used: 0,
        total_company_quota_sisa: 0
      }

      TokenService.saveCounter(JSON.stringify(counter))

      this.$store.commit("setCounter", counter)
    },
    methods: {
      async fetch () {
        await get('config')
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            res.results.data[0].color = JSON.parse(res.results.data[0].color)

            TokenService.saveCompany(JSON.stringify(res.results.data[0]))

            this.$store.commit("setCompany", res.results.data[0])
            
            if (res.results.data[0].color.length > 0) {
              res.results.data[0].color.map((obj) => {
                if (obj.active) {
                  TokenService.saveColor(obj.hex)

                  this.$store.commit("setColor", obj.hex)
                }
              })
            } else {
              TokenService.saveColor('#DD5826')

              this.$store.commit("setColor", '#DD5826')
            }
          }
        })
      },

      async recaptcha() {
        this.message.error = ''
        // (optional) Wait until recaptcha has been loaded.
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true
          await this.$recaptchaLoaded()

          // Execute reCAPTCHA with action "login".
          const token = await this.$recaptcha('login')

          // let formData = new FormData()
          //       formData.append('secret', '6LdXR4oqAAAAAL5KjnCLuncKPczuNlUCSsGgN7Gl')
          //       formData.append('response', '03AFcWeA5W_bPdL1iPsBMELSrK24b91zCMYrK30Pko2P2rbwDy0cfubF9qVXxKRBm-bgxBMmdvHjmPVlvOjZcorbWk_1CsVkSCL_r47WwINJOvXo-nH0ndzCLKgA1UG2W0b_XR8mSkbnF-gu5Cmg_Ahfofcq2YCbuaGvZJZSTO57MJktMsZo5g3-ZkRyqO7O-WozMhLzZ9xiqPI-Av7uOTmjyTHrXlmCxL2d8tXZHpKzcu3pnLx7tfU6858tRaDcmfThwGnf-ll5Qs4ha0OsWb5Vq6Lgwu63RgqWi4FYNVNktM2jD9Z4IzpDokFNCN16qH2bGxofr9g1-wx7uG4OWLwN_Lniy84if5Tm1YhRUCRCQWE7cRNCurKg_QpmxsHo2hj0weokq70eLVeOnzqgqqKc3eMMiDW7txv3c_Fa1KX4Um2zGDoXrDwJey5j1Aho_5h0ApxaVql3bRJ8IVRPpPBhOxb8VWQD90cYanbu6YpIyEbT6QzSGAK3JRC8axsyLbuDF9OFwgGnJagVKolwKIQUPRW6IBJjzhDhwr4rX_UvPX4ext4jp8PtyyfCwaQEjGzZcdHxOkDhupQcnsY7uuGkGrVmObo_GeMS2RCz2pFsbUDss9qrrENl1cDe87WaKkKSQ2xPbRJIV5ertFY0CJnwzD6sM9xrZmX7PlWwyIZDuVwqTOHNeTHpDAnKsI_tNxPUAgxo93BZDsaloQPcYQbc_mr2NxKi4a-y7ZmxmaXMUVR-VDrQX_NvTC7cgHqxcpGvMmz6eSD8YH3lLPn4jMMZA3SnIRvH1Uwx_Ix2BPRKFNQESZVsVyuslKOlRmlnskx7zCAqi_rhbvqkum2ZefCXOwIGT9Lv9vWtq6fDr9e_X-UxbUVV3QEGJK11sEfdF1xr6oSX_HDofNSfNWYd9DhbULocYV0k3L8PE5zUueQfvlwZe6pLn8rEoDNnXtbsiwfgEZfLM9IhtOBDyVeFjHjNgxclHg6VV8SDxYuuYh5yoT6xNWzg_KDZhxxXQrj8BD_a66EimgJKe84k_dCufwdAyDDwg9H7HPIx2OGnk3AhpeWSnT8bHH0Gu_Pk1A5csxHoxAvOcH8_J7k80nePFMoPu82vY74Emtd7WdcTkJSfGhwGDCCDLHBL2UpyoJtakrJE36OtCgnCOxNek8qTZnuyIIHJuR4taqr2KdAmCnAefngo7CSTzQIKR3-b-vNzTpe4_KXxBl7MlSxM2kh4W7_BeBdYrYRz7Zc_4CvP_Q050ebnOuBw6GTPOOKf0g3sSdqUptoAYE4JmYJfaPmCru57WpDJkAM3vT4-C9jXTOqAm5q_-vW5ABpIPvMMFlp5mROShue-XUyQxrVy6ZV_vftT8O3A3lroia5q8Z6moj46zV5BLBMsqZhOVghuUV_JOJnGt-z-FDK7xF8-Rxa2LnYCyLCAMhCT6Y3jkDmvAGxw0yn7sC6cHH9o9ePRcxF3P3XB0stz_e3m10CnL-oxO-dhVwzqhlFvJt4LX67Aepzh_rul084oW0iBFSVHOjj6OqWGiAgsaFMGTda0M7iGkTX2eEE1uahNsuO3jWBIQyoB8a-bT6mi5dt8h8U9WNeuiCNsoxNNPCKtaSk8sqJallrtYLyIvdssYO4iRXewyEaPo5V6O1J2yYEQQJ8wI3tO3Cead-wsKGbtWx7cclyL5vz9mspPmMNoPDmnPBvUhauhlOyBt7gwNdFJnpk3p8nsMsnxMqGf-2FUjJaWjdIPb7C7Ikf-ywL0FQX0_PyDM7KGawS-Y6gOz1P8Ssol3MgH6xQwlynufpcIiBdhl0iwJhTkS1ofLGb2dUHywYi1ae5WbSEhXBy6umVgGBCRZ12WdjmsPKy-CUIegjpxaqpyiIyS7Kv5x0h41MMHajXJ3wxffrQSfWWilNr8TFPZfI4AHi3bAnNz36_EP4')

          //   await fetch(`https://www.google.com/recaptcha/api/siteverify`, {
          //     method: 'POST',
          //     mode: 'no-cors',
          //     body: formData
          //   })
          //   .then(res => res.json())
          //   .then(response => {
          //     console.log(response)
          //   })

          let params = {
            // secret: '6Lf8XowqAAAAAHog6hbEywGNn53pqd5YEPLGAfHM',
            token: token,
            email: this.form.username,
          }

          await axios({
            url: `${process.env.VUE_APP_API_URL}admin/auth/validate`,
            method: 'POST',
            data: params,
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: process.env.VUE_APP_XAUTH
            }
          }).then((response) => {
            let res = response
            this.captcha = res.data.results.data.success

            if (this.captcha) {
              this.save(res.data.results.data.token)
            } else {
              this.process.form = false
              this.message.error = 'Kami menduga adanya aktivitas otomatis. Harap coba lagi untuk mengonfirmasi bahwa Anda adalah pengguna asli'
            }
            
          })
        }

        // Do stuff with the received token.
      },

      async save (token) {
        this.message.error = ''

        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true

          await post('admin/auth/login', {
            data: {
              username: this.form.username,
              password: this.form.password,
              device: this.form.device,
              token: token
            }
          })
          .then(response => {
            let res = response.data

            if (res.status === 200) {
              // console.log(res.results.data)
              let user = res.results.data,
                  menu = []

              if (user.role === 'admin') {
                menu = [
                  {
                    title: 'Dashboard',
                    icon: require('@/assets/icon/dashboard.png'),
                    link: '/dashboard',
                    active: true,
                    sub_menu: []
                  },
                  {
                    title: 'Anggaran Murni',
                    icon: require('@/assets/icon/program.png'),
                    link: '/program',
                    active: false,
                    sub_menu: []
                  },
                  {
                    title: 'Anggaran P1',
                    icon: require('@/assets/icon/program.png'),
                    link: '/program-p1',
                    active: false,
                    sub_menu: []
                  },
                  {
                    title: 'Anggaran Perubahan',
                    icon: require('@/assets/icon/update.png'),
                    link: '/program-perubahan',
                    active: false,
                    sub_menu: []
                  },
                  {
                    title: 'Laporan',
                    icon: require('@/assets/icon/laporan.png'),
                    link: '/laporan',
                    active: false,
                    sub_menu: [
                      {
                        title: 'Perkembangan Fisik & Keuangan',
                        link: '/laporan/perkembangan',
                        active: false
                      },
                      {
                        title: 'Capaian Kinerja',
                        link: '/laporan/capaian',
                        active: false
                      },
                      {
                        title: 'Kendala',
                        link: '/laporan/kendala',
                        active: false
                      },
                      {
                        title: 'Rekap OPD',
                        link: '/laporan/rekapitulasi',
                        active: false
                      },
                      {
                        title: 'Perkembangan Fisik & Keuangan Publik',
                        link: '/laporan/perkembangan-opd-public',
                        active: false
                      },
                      {
                        title: 'Rekap OPD Publik',
                        link: '/laporan/rekap-opd-public',
                        active: false
                      }
                    ]
                  },
                  {
                    title: 'Perbandingan SP2D',
                    icon: require('@/assets/icon/comparison.png'),
                    link: '/perbandingan-sp2d',
                    active: true,
                    sub_menu: []
                  },
                  {
                    title: 'User',
                    icon: require('@/assets/icon/user.png'),
                    link: '/user',
                    active: true,
                    sub_menu: []
                  },
                  {
                    title: 'Konfigurasi',
                    icon: require('@/assets/icon/setting.png'),
                    link: '/master',
                    active: false,
                    sub_menu: [
                      {
                        title: 'Perangkat Daerah',
                        icon: require('@/assets/icon/company.png'),
                        link: '/master/perusahaan',
                        active: false,
                        sub_menu: []
                      },
                      {
                        title: 'Unit',
                        icon: require('@/assets/icon/unit.png'),
                        link: '/master/unit',
                        active: false,
                        sub_menu: []
                      },
                      {
                        title: 'Dokumen',
                        icon: require('@/assets/icon/upload_folder.png'),
                        link: '/master/document',
                        active: false,
                        sub_menu: []
                      },
                      {
                        title: 'Import Data',
                        icon: require('@/assets/icon/import.png'),
                        link: '/master/import',
                        active: false,
                        sub_menu: []
                      },
                      {
                        title: 'Import Data Perubahan',
                        icon: require('@/assets/icon/file-download.png'),
                        link: '/master/import-perubahan',
                        active: false,
                        sub_menu: []
                      }
                    ]
                  }
                ]
              } else {
                menu = [
                  {
                    title: 'Dashboard',
                    icon: require('@/assets/icon/dashboard.png'),
                    link: '/dashboard',
                    active: true,
                    sub_menu: []
                  },
                  {
                    title: 'Anggaran Murni',
                    icon: require('@/assets/icon/program.png'),
                    link: '/program',
                    active: false,
                    sub_menu: []
                  },
                  {
                    title: 'Anggaran P1',
                    icon: require('@/assets/icon/program.png'),
                    link: '/program-p1',
                    active: false,
                    sub_menu: []
                  },
                  {
                    title: 'Anggaran Perubahan',
                    icon: require('@/assets/icon/update.png'),
                    link: '/program-perubahan',
                    active: false,
                    sub_menu: []
                  },
                  {
                    title: 'Laporan',
                    icon: require('@/assets/icon/laporan.png'),
                    link: '/laporan',
                    active: false,
                    sub_menu: [
                      {
                        title: 'Perkembangan Fisik & Keuangan',
                        link: '/laporan/perkembangan',
                        active: false
                      },
                      {
                        title: 'Capaian Kinerja',
                        link: '/laporan/capaian',
                        active: false
                      },
                      {
                        title: 'Kendala',
                        link: '/laporan/kendala',
                        active: false
                      },
                    ]
                  },
                  {
                    title: 'Konfigurasi',
                    icon: require('@/assets/icon/setting.png'),
                    link: '/master',
                    active: false,
                    sub_menu: [
                      {
                        title: 'Informasi Unit',
                        icon: require('@/assets/icon/unit.png'),
                        link: '/master/informasi-unit',
                        active: false,
                        sub_menu: []
                      },
                      {
                        title: 'Dokumen',
                        icon: require('@/assets/icon/upload_folder.png'),
                        link: '/master/document',
                        active: false,
                        sub_menu: []
                      },
                      // {
                      //   title: 'Import Data Perubahan',
                      //   icon: require('@/assets/icon/file-download.png'),
                      //   link: '/master/import-perubahan',
                      //   active: false,
                      //   sub_menu: []
                      // }
                      {
                        title: 'Import Data',
                        icon: require('@/assets/icon/import.png'),
                        link: '/master/import',
                        active: false,
                        sub_menu: []
                      },
                      // {
                      //   title: 'Import Data Perubahan',
                      //   icon: require('@/assets/icon/file-download.png'),
                      //   link: '/master/import-perubahan',
                      //   active: false,
                      //   sub_menu: []
                      // }
                    ]
                  }
                ]

                let menu_gabungan = [
                  {
                    title: 'Dashboard',
                    icon: require('@/assets/icon/dashboard.png'),
                    link: '/dashboard',
                    active: true,
                    sub_menu: []
                  },
                  {
                    title: 'Anggaran Murni',
                    icon: require('@/assets/icon/program.png'),
                    link: '/program',
                    active: false,
                    sub_menu: []
                  },
                  {
                    title: 'Anggaran P1',
                    icon: require('@/assets/icon/program.png'),
                    link: '/program-p1',
                    active: false,
                    sub_menu: []
                  },
                  {
                    title: 'Anggaran Perubahan',
                    icon: require('@/assets/icon/update.png'),
                    link: '/program-perubahan',
                    active: false,
                    sub_menu: []
                  },
                  {
                    title: 'Laporan',
                    icon: require('@/assets/icon/laporan.png'),
                    link: '/laporan',
                    active: false,
                    sub_menu: [
                      {
                        title: 'Perkembangan Fisik & Keuangan',
                        link: '/laporan/perkembangan',
                        active: false
                      },
                      {
                        title: 'Capaian Kinerja',
                        link: '/laporan/capaian',
                        active: false
                      },
                      {
                        title: 'Kendala',
                        link: '/laporan/kendala',
                        active: false
                      },
                      {
                        title: 'Rekap Gabungan',
                        link: '/laporan/rekapitulasi-gabungan',
                        active: false
                      }
                    ]
                  },
                  {
                    title: 'Konfigurasi',
                    icon: require('@/assets/icon/setting.png'),
                    link: '/master',
                    active: false,
                    sub_menu: [
                      {
                        title: 'Informasi Unit',
                        icon: require('@/assets/icon/unit.png'),
                        link: '/master/informasi-unit',
                        active: false,
                        sub_menu: []
                      },
                      {
                        title: 'Dokumen',
                        icon: require('@/assets/icon/upload_folder.png'),
                        link: '/master/document',
                        active: false,
                        sub_menu: []
                      },
                      // {
                      //   title: 'Import Data Perubahan',
                      //   icon: require('@/assets/icon/file-download.png'),
                      //   link: '/master/import-perubahan',
                      //   active: false,
                      //   sub_menu: []
                      // }
                      {
                        title: 'Import Data',
                        icon: require('@/assets/icon/import.png'),
                        link: '/master/import',
                        active: false,
                        sub_menu: []
                      },
                      // {
                      //   title: 'Import Data Perubahan',
                      //   icon: require('@/assets/icon/file-download.png'),
                      //   link: '/master/import-perubahan',
                      //   active: false,
                      //   sub_menu: []
                      // }
                    ]
                  }
                ]

                menu = user.unit_id == '42' || user.unit_id == '43' || user.unit_id == '41' || user.unit_id == '32' || user.unit_id == '4' || user.unit_id == '6' || user.unit_id == '1' || user.unit_id == '492' || user.unit_id == '501' || user.unit_id == '496' || user.unit_id == '493' || user.unit_id == '537' || user.unit_id == '500' || user.unit_id == '494' || user.unit_id == '495' || user.unit_id == '538' || user.unit_id == '492' || user.unit_id == '326' || user.unit_id == '327' || user.unit_id == '328' || user.unit_id == '330' || user.unit_id == '329' || user.unit_id == '325' || user.unit_id == '334' || user.unit_id == '335' || user.unit_id == '313' || user.unit_id == '179' || user.unit_type == "Pendidikan" || user.unit_type == "Puskesmas" ? menu_gabungan : menu
              }

              
              TokenService.saveToken(
                res.results.token,
                JSON.stringify(user),
                JSON.stringify(menu)
              )

              TokenService.saveReload(false)

              TokenService.saveYear(new Date().getFullYear())

              window.location = `${process.env.BASE_URL}dashboard`
            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      }
    }
  }
</script>